import React, { FunctionComponent, useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet';
import { getTagAttributes } from '../../../helpers/html.utils';
import { IMaster } from '../../../models/master/master.model';

type MasterHeaderProps = {
  data: IMaster;
  enableEnsighten: () => void;
};

export const MasterHeader: FunctionComponent<MasterHeaderProps> = (props: MasterHeaderProps) => {
  useLayoutEffect(() => {
    // Add Ensighten JS
    props.enableEnsighten();
  }, [props]);

  return (
    <Helmet>
      {/*HTML Lang*/}
      <html lang={props.data.metaData.htmlLang} />

      {/* Head Scripts */}
      {props.data.scripts.head?.map((script, i) => {
        if (script.innerHtml)
          return (
            <script key={i} {...getTagAttributes(script.attributes)}>
              {script.innerHtml}
            </script>
          );
        else return <script key={i} {...getTagAttributes(script.attributes)} />;
      })}

      {/* Head Links */}
      {props.data.metaData.links?.map((link, i) => {
        return <link key={i} {...getTagAttributes(link.attributes)} />;
      })}

      {/* Head Meta */}
      {props.data.metaData.metaTags?.map((meta, i) => {
        return <meta key={i} {...getTagAttributes(meta.attributes)} />;
      })}
    </Helmet>
  );
};

export default MasterHeader;
